var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h22v22H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 11a8.25 8.25 0 10-9.54 8.15v-5.765H7.617V11h2.095V9.182c0-2.067 1.232-3.21 3.116-3.21.903 0 1.847.162 1.847.162v2.03h-1.04c-1.025 0-1.345.636-1.345 1.288V11h2.288l-.366 2.385H12.29v5.765A8.252 8.252 0 0019.25 11",
    fill: "#fff"
  })));
}
export default SvgFacebook2;